import * as React from 'react';

import { AirlinesOptions, CabinClassOptions, MoreFilters, TravelerOptions, TripTypeOptions } from '.';

import {
  FlightsSearchFormAirlineOption,
  FlightsSearchFormCabinClassOption,
  FlightsSearchFormMoreFiltersOption,
  FlightsSearchFormOptionType,
  FlightsSearchFormTripTypeOption
} from 'types/search/wizard';
import { InteractableFieldComponentProps } from 'types/shared';

interface AdvancedSearchOptionProps extends InteractableFieldComponentProps {
  searchOption: FlightsSearchFormOptionType;
}

export const AdvancedSearchOption = ({ searchOption, onFieldInteraction }: AdvancedSearchOptionProps) => {
  switch (searchOption.__typename) {
    case 'FlightsSearchFormAirlineOption':
      return (
        <AirlinesOptions
          searchOption={searchOption as FlightsSearchFormAirlineOption}
          onFieldInteraction={onFieldInteraction}
        />
      );
    case 'FlightsSearchFormCabinClassOption':
      return (
        <CabinClassOptions
          searchOption={searchOption as FlightsSearchFormCabinClassOption}
          onFieldInteraction={onFieldInteraction}
        />
      );
    case 'FlightsSearchFormMoreFiltersOption':
      return (
        <MoreFilters
          searchOption={searchOption as FlightsSearchFormMoreFiltersOption}
          onFieldInteraction={onFieldInteraction}
        />
      );
    case 'FlightsSearchFormTravelersOption':
      return <TravelerOptions onFieldInteraction={onFieldInteraction} />;
    case 'FlightsSearchFormTripTypeOption':
      return (
        <TripTypeOptions
          searchOption={searchOption as FlightsSearchFormTripTypeOption}
          onFieldInteraction={onFieldInteraction}
        />
      );
    default:
      return <></>;
  }
};
